import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AuditLogModal = ({ open, handleClose, tenant }) => {
    if (!tenant) return null;

    const auditLogs = [
        {
            id: 1,
            action: 'Created',
            actor: 'Admin User',
            timestamp: '2024-01-15 10:30 AM',
            details: 'Tenant account created',
        },
        {
            id: 2,
            action: 'Updated',
            actor: 'Admin User',
            timestamp: '2024-01-15 11:45 AM',
            details: 'Contact information updated',
        },
        {
            id: 3,
            action: 'Status Changed',
            actor: 'System',
            timestamp: '2024-01-15 02:00 PM',
            details: 'Status changed to Active',
        },
        {
            id: 4,
            action: 'Verified',
            actor: 'Manager User',
            timestamp: '2024-01-15 03:15 PM',
            details: 'Tenant verification completed',
        },
        {
            id: 5,
            action: 'Updated',
            actor: 'Admin User',
            timestamp: '2024-01-15 04:30 PM',
            details: 'Apartment details updated',
        },
    ];

    const getActionColor = (action) => {
        switch (action) {
            case 'Created':
                return { bg: 'rgba(16, 185, 129, 0.1)', text: '#10b981' };
            case 'Updated':
                return { bg: 'rgba(72, 127, 255, 0.1)', text: '#487fff' };
            case 'Status Changed':
                return { bg: 'rgba(59, 130, 246, 0.1)', text: '#3b82f6' };
            case 'Verified':
                return { bg: 'rgba(34, 197, 94, 0.1)', text: '#22c55e' };
            default:
                return { bg: 'rgba(107, 114, 128, 0.1)', text: '#6b7280' };
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle
                sx={{
                    background: 'linear-gradient(135deg, #9333ea 0%, #a855f7 100%)',
                    color: 'white',
                    p: 2.5,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
                    Activity Log - {tenant.name}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    size="small"
                    sx={{
                        color: 'white',
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        '&:hover': {
                            backgroundColor: 'rgba(255,255,255,0.25)',
                        },
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 3, backgroundColor: '#f8fafc' }}>
                {/* Summary Stats */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                        gap: 2,
                        mb: 3,
                    }}
                >
                    <Box sx={{ backgroundColor: 'white', p: 2, borderRadius: 1, textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: '#1f2937' }}>
                            {auditLogs.length}
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
                            Total Activities
                        </Typography>
                    </Box>
                    <Box sx={{ backgroundColor: 'white', p: 2, borderRadius: 1, textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: '#1f2937' }}>
                            2
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
                            Updates
                        </Typography>
                    </Box>
                    <Box sx={{ backgroundColor: 'white', p: 2, borderRadius: 1, textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: '#1f2937' }}>
                            1
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
                            Verifications
                        </Typography>
                    </Box>
                </Box>

                {/* Activity Timeline */}
                <Typography
                    sx={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color: '#1f2937',
                        mb: 2,
                        textTransform: 'uppercase',
                    }}
                >
                    Activity Timeline
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {auditLogs.map((log, index) => {
                        const colors = getActionColor(log.action);
                        return (
                            <Box
                                key={log.id}
                                sx={{
                                    display: 'flex',
                                    gap: 2,
                                    p: 2,
                                    backgroundColor: 'white',
                                    borderRadius: 1,
                                    borderLeft: '4px solid #9333ea',
                                }}
                            >
                                <Box>
                                    <Chip
                                        label={log.action}
                                        size="small"
                                        sx={{
                                            backgroundColor: colors.bg,
                                            color: colors.text,
                                            fontWeight: 600,
                                            mb: 1,
                                        }}
                                    />
                                    <Typography sx={{ fontSize: '0.875rem', color: '#1f2937', mb: 0.5 }}>
                                        {log.details}
                                    </Typography>
                                    <Typography sx={{ fontSize: '0.75rem', color: '#6b7280' }}>
                                        By {log.actor} • {log.timestamp}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default AuditLogModal;
